import WorkstationAvailability, { GetWorkstationAvailabilitiesPayload } from "app/models/workstationAvailability"

export enum Types {
  GET = "WORKSTATIONS_AVAILABILITIES_GET",
  GET_SUCCESS = "WORKSTATIONS_AVAILABILITIES_GET_SUCCESS",
  GET_FAIL = "WORKSTATIONS_AVAILABILITIES_GET_FAIL",
}

export type Action =
  | GetWorkstationAvailabilitiesAction
  | GetWorkstationAvailabilitiesSuccessAction
  | GetWorkstationAvailabilitiesFailAction

export type GetWorkstationAvailabilitiesAction = {
  payload: GetWorkstationAvailabilitiesPayload
  type: Types.GET
}

export type GetWorkstationAvailabilitiesSuccessAction = {
  payload: { data: WorkstationAvailability[] }
  type: Types.GET_SUCCESS
}

export type GetWorkstationAvailabilitiesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export function getWorkstationAvailabilities(
  payload: GetWorkstationAvailabilitiesPayload,
): GetWorkstationAvailabilitiesAction {
  return {
    payload,
    type: Types.GET,
  }
}

export function getWorkstationAvailabilitiesSuccess(
  data: WorkstationAvailability[],
): GetWorkstationAvailabilitiesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getWorkstationAvailabilitiesFail(errors: object): GetWorkstationAvailabilitiesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
